module.exports = __webpack_public_path__ + "img/page.ca818f9f.svg";